var LEARN_MORE_LINK_URL = 'https://learn.microsoft.com/en-us/azure/marketplace/marketplace-geo-availability-currencies';

export { LEARN_MORE_LINK_URL };
